import { CHANNEL_TO_VENDOR_LABEL, KNOWN_VENDOR_LABELS } from '@devglobalbot/global-contracts'

/**
 * Normalizes the legacy advanced-search channel selection (match.hb).
 * Accepts the old single-string shape ('all', 'Todos', 'whatsapp', 'Telegram')
 * and the new array shape, returning an array without 'all'/'Todos' sentinels.
 * Empty array = no channel filter (every channel, including gbm/rcs).
 */
export function normalizeHbSelection (hb) {
  if (Array.isArray(hb)) {
    return [...new Set(hb.filter(v => v && v !== 'all' && v !== 'Todos'))]
  }
  if (typeof hb === 'string' && hb && hb !== 'all' && hb !== 'Todos') return [hb]
  return []
}

/**
 * Applies the channel selection to a Mongo match being built client-side
 * (legacy requestMatch flow). Semantics:
 *   - vendors only      → hb equality (1) or hb $in (2+)
 *   - webchat only      → $nor of every vendor label (parity with the old
 *                         single-select behavior)
 *   - webchat + vendors → $and-ed $or of the two conditions above
 *     ($nin matches documents without hb, same as the $nor list)
 * Always pushes into existing $nor/$and instead of overwriting — other
 * filters (cFinished, dialogue, departments) share those keys.
 */
export function applyHbSelectionToMatch (match, hb) {
  const selected = normalizeHbSelection(hb)
  if (selected.length === 0) return

  const wantsWebchat = selected.includes('webchat')
  const vendorLabels = selected
    .filter(c => c !== 'webchat')
    .map(c => CHANNEL_TO_VENDOR_LABEL[String(c).toLowerCase()])
    .filter(Boolean)

  if (wantsWebchat && vendorLabels.length === 0) {
    if (!match.$nor) match.$nor = []
    KNOWN_VENDOR_LABELS.forEach(label => match.$nor.push({ hb: label }))
    return
  }

  if (!wantsWebchat) {
    if (vendorLabels.length === 1) {
      match.hb = vendorLabels[0]
    } else if (vendorLabels.length > 1) {
      match.hb = { $in: vendorLabels }
    }
    return
  }

  if (!match.$and) match.$and = []
  match.$and.push({
    $or: [
      { hb: { $in: vendorLabels } },
      { hb: { $nin: [...KNOWN_VENDOR_LABELS] } }
    ]
  })
}
